var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlignVerticalCenter = function SvgAlignVerticalCenter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.333 12.667a.667.667 0 0 1-.666.666H9.333a.667.667 0 0 1-.666-.666V3.333c0-.368.298-.666.666-.666h1.334c.368 0 .666.298.666.666zM7.333 10.667a.667.667 0 0 1-.666.666H5.333a.667.667 0 0 1-.666-.666V5.333c0-.368.298-.666.666-.666h1.334c.368 0 .666.298.666.666z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.333 7.333H2.667a.667.667 0 0 0 0 1.334h10.666a.667.667 0 1 0 0-1.334"
  }))));
};
export default SvgAlignVerticalCenter;